// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop-module--scroll-to-top--RhMbD"};